import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { v4 as uuid } from 'uuid';

import { FinnairBoundItem, FinnairPassengerItem } from '@fcom/dapi/api/models';
import { FinnairServiceItemWithUpsell } from '@fcom/dapi/interfaces';
import { getIconForServiceCategory } from '@fcom/dapi/utils';

@Component({
  selector: 'fin-included-product-item',
  styleUrls: ['./included-product-item.component.scss'],
  templateUrl: './included-product-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncludedProductItemComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  uuid = uuid();

  @Input() category: string;
  @Input() buttonTranslationKey: string;
  @Input() additionalTitle: string;
  @Input() includePaddings = true;
  @Input() expandOpen = false;
  @Input() disabled = false;
  @Input() displaySeatReassignMessage = false;
  @Input() isShortHaulFlight: boolean;
  @Input() passengers: FinnairPassengerItem[];
  @Input() bound: FinnairBoundItem;
  @Input() service: FinnairServiceItemWithUpsell;

  getIconForService(): SvgLibraryIcon {
    return getIconForServiceCategory(this.category);
  }
}
